export const FINGERPRINTING_VIEW = () => {
  return (
    <>
      <div className="sl-pb-6 sl-text-center">
        <h1 className="sl-fonts">Shields detected</h1>
      </div>
      <div className="sl-space-y-6 sl-text-center">
        <p>
          Make sure fingerprinting protection isn&apos;t enabled in your
          browser, if you are a Brave user turn off shields and try again.
        </p>
        <p className="sl-text-left">
          Copy your progress before allowing fingerprinting, as the page will be
          reloaded and any unsaved progress will be lost.
        </p>
      </div>
    </>
  )
}

export default FINGERPRINTING_VIEW
